
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'administrationimprestIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'administrationimprest',
				windowName: '行政备用金',
				windowType: 'modal',
				currentrow:null,
				list_footerField:[
					{field:'amt',toFixed:2}
				],
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500,2000],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.$refs[this.importRef].importcomfig = this.importcomfig
			this.$refs[this.importRef].moduleImport = this.moduleImport
			
		},
		computed: {

		},

		methods: {
			applyimprest(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let amount = 0
				let serialNo = data.map((item)=>{
					amount += parseFloat(item.amt)
					return item.serialNo
				})
				
	
	
	
				let flowid = 36
				this.$api.flow.getSingleFlowTemplate(flowid).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'transferaccounts',								
								id: 0,
								controlltype: 1,
								windowName: '备用金转账',
								extra: JSON.stringify({
									sourceordercode: serialNo.join(','),
									amount:amount,
									rcvAcc:'Wenzjinx@163.com',
									uses:10018
								}),
								isflow: 1,
								flowid: flowid
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, this.moduleName + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(this.moduleName + 'form open')
							}
						}
							
					}
				})
			}
			// importcomfig(){
			// 	return new Promise((reslove)=>{
			// 		let res = [
			// 			{code:'serialId',title:'序列号ID',require:true},
			// 			{code:'serialNo',title:'关联单据'}
			// 		]
			// 		reslove(res)
			// 	})
			// },
		},
		components: {
				
		}
	}
</script>
